






























import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import Moment from "moment-timezone";

class PageReadListRequest extends PageRequest {
    keyword: string;
    groupId: number;
}
@Component({
    components: {},
})
export default class MessageSendGroupDetail extends AbpBase {
    @Prop({ type: Boolean, default: false }) value: boolean;
    @Prop({ type: Number, default: "" }) groupId: number;
    pagerequest: PageReadListRequest = new PageReadListRequest();
    page: number = 0;
    pageSize: number = 10;
    totalCount: number = 0;
    currentPage: number = 1;
    targetUser: string;
    list: any[] = [];
    create() { }
    created() {

    }
    cancel() {
        this.$emit("input", false);
    }
    visibleChange(value: boolean) {
        if (!value) {
            this.$emit("input", value);
        }
        this.getpage();
    }
    data() {
        return {
            arealist: [],
            normalizer(node) {
                if (node.children && !node.children.length) {
                    delete node.children;
                }
                return {
                    id: node.id,
                    label: node.label,
                    children: node.children,
                };
            },
            datepicker: {
                shortcuts: [
                    {
                        text: this.L("OneWeek"),
                        value() {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            return [start, end];
                        },
                    },
                    {
                        text: this.L("OneMonth"),
                        value() {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            return [start, end];
                        },
                    },
                    {
                        text: this.L("ThreeMonths"),
                        value() {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            return [start, end];
                        },
                    },
                ],
            },
        };
    }
    pageChange(page: number) {
        this.page = page;
        this.currentPage = page;
        this.getpage();
    }
    pagesizeChange(pagesize: number) {
        this.pageSize = pagesize;

        this.getpage();
    }
    async getpage() {

        this.pagerequest.maxResultCount = this.pageSize
        this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
        await this.$store.dispatch({
            type: "messagesendgroup/getMessageSendGroupDetail",
            data: this.pagerequest,
        }).then((val) => {
            this.targetUser = val.targetUser;
            this.totalCount = val.totalCount;
            this.list = val.deviceInfoList;
        }).catch((err) => {
            console.log(err);
        });
    }

    get loading() {
        return this.$store.state.readrecord.loading;
    }
    columns = [
        {
            type: "index",
            width: 80,
            align: "left",
            title: this.L("IndexNo"),
        },
        {
            title: this.L("DeviceNo"),
            key: "deviceNo",
            width: 130,
        },
        {
            title: this.L("RoomNo"),
            key: "roomNo",
            width: 130,
        },
        {
            title: this.L("Location"),
            key: "location",
            width: 130,
        },
    ];
    @Watch("groupId")
    getitemId() {
        this.pagerequest.groupId = this.groupId;
    }
}
